import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ParamManageFilledStandard.js";
import l from "../components/PfIcon.js";
const a = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(l, o(t, {
    icon: d
  }), null);
};
a.displayName = "ParamManageFilledStandard";
a.inheritAttrs = !1;
export {
  a as default
};
